/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSecurityClearanceResponse
 */
export interface UserSecurityClearanceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserSecurityClearanceResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceResponse
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceResponse
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof UserSecurityClearanceResponse
     */
    maxSecurityLevel?: number;
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceResponse
     */
    grantedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserSecurityClearanceResponse
     */
    grantedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserSecurityClearanceResponse
     */
    expiresAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceResponse
     */
    errorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecurityClearanceResponse
     */
    errorDetails?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSecurityClearanceResponse
     */
    active?: boolean;
}

/**
 * Check if a given object implements the UserSecurityClearanceResponse interface.
 */
export function instanceOfUserSecurityClearanceResponse(value: object): value is UserSecurityClearanceResponse {
    return true;
}

export function UserSecurityClearanceResponseFromJSON(json: any): UserSecurityClearanceResponse {
    return UserSecurityClearanceResponseFromJSONTyped(json, false);
}

export function UserSecurityClearanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSecurityClearanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'maxSecurityLevel': json['maxSecurityLevel'] == null ? undefined : json['maxSecurityLevel'],
        'grantedBy': json['grantedBy'] == null ? undefined : json['grantedBy'],
        'grantedAt': json['grantedAt'] == null ? undefined : (new Date(json['grantedAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'errorDetails': json['errorDetails'] == null ? undefined : json['errorDetails'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function UserSecurityClearanceResponseToJSON(json: any): UserSecurityClearanceResponse {
    return UserSecurityClearanceResponseToJSONTyped(json, false);
}

export function UserSecurityClearanceResponseToJSONTyped(value?: UserSecurityClearanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'timezone': value['timezone'],
        'id': value['id'],
        'userId': value['userId'],
        'tenantId': value['tenantId'],
        'maxSecurityLevel': value['maxSecurityLevel'],
        'grantedBy': value['grantedBy'],
        'grantedAt': value['grantedAt'] == null ? undefined : ((value['grantedAt']).toISOString()),
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'errorCode': value['errorCode'],
        'errorDetails': value['errorDetails'],
        'active': value['active'],
    };
}

